import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { SelectWrapper, SelectBox } from 'routes/Results/ProLayout/styles';
import { withAuctionCore } from 'agent';
import Select from 'react-select';
import useStores from '../../hooks/useStore';
import useReports from '../../hooks/useReports';
import {
  TabButtonsWrapper, TabButtonItem, TabText, Icon, TabsComponent, TextHolder,
} from './styles';

const tabVariant = {
  active: {
    width: '85%',
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
  inactive: {
    width: '15%',
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
};

const tabTextVariant = {
  active: {
    opacity: 1,
    x: 0,
    display: 'block',
    transition: {
      type: 'tween',
      duration: 0.3,
      delay: 0.3,
    },
  },
  inactive: {
    opacity: 0,
    x: -30,
    transition: {
      type: 'tween',
      duration: 0.3,
      delay: 0.1,
    },
    transitionEnd: { display: 'none' },
  },
};

const TabItems = [
  {
    title: 'Condition',
    id: 'condition',
    icon: 'wrench',
    color: '#bfbfbf',
  }, {
    title: 'Charts',
    id: 'charts',
    icon: 'chart-line',
    color: '#5d5dff',
  }, {
    title: 'History',
    id: 'saleshistory',
    icon: 'gavel',
    color: '#5d5dff',
  }, {
    title: 'Value Guide',
    id: 'vgplus',
    icon: 'table',
    color: '#5d5dff',
    width: 110,
  }];

const TabButtons = observer(({ auctioncore }) => {
  const { UIStore } = useStores();
  const { setReports } = useReports(auctioncore);
  const [locations, setLocations] = useState([]);
  const {
    condition,
    setLoading,
    valueLocation,
    setProperty,
  } = UIStore;
  useEffect(() => {
    auctioncore.getLocations()
      .then((response) => {
        setLocations(response.data.lookupItems);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    const reportSet = async () => {
      setLoading(true);
      await setReports(condition, true, true);
      setLoading(false);
    };
    reportSet();
  }, [valueLocation]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: 'white',
      marginBottom: 0,
      width: '300px',
    }),
    option: (styles, {
      isFocused,
    }) => ({
      ...styles,
      color: 'black',
      textAlign: 'left',
      backgroundColor: isFocused ? '#ccc' : null,
      width: '300px',
    }),
  };

  const { activeTab, setActiveTab } = UIStore;
  return (
    <TabsComponent>
      <TabButtonsWrapper>
        {TabItems.map((tab, i) => (
          <TabButtonItem active={i === activeTab} onClick={() => setActiveTab(i)} animate={i === activeTab ? 'active' : 'inactive'} variants={tabVariant}>

            <a href={`#${tab.id}`}>
              <Icon icon={tab.icon} color="white" size="1x" />
              <TabText width={tab.width} variants={tabTextVariant}>{tab.title}</TabText>
            </a>

          </TabButtonItem>
        ))}
      </TabButtonsWrapper>
      <SelectWrapper>
        <TextHolder>Auction Location:</TextHolder>
        <Select
          isSearchable={false}
          placeholder="All Locations"
          defaultValue={null}
          styles={colourStyles}
          options={[
            { label: 'All Locations', value: '' }, // Hardcoded option
            ...locations.map((item) => ({
              label: item.text,
              value: item.value,
            })),
          ]}
          onChange={(e) => setProperty('valueLocation', e.label)}
        />
      </SelectWrapper>
    </TabsComponent>
  );
});

export default withAuctionCore(TabButtons);
